// @ts-nocheck
// Greif UI Kit = line-drop-trailer
import React from "react";

const DropTrailerLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.119 4.363c.926 0 1.679.736 1.679 1.644v10.27h1.971c.58 0 1.05.46 1.05 1.026 0 .568-.47 1.028-1.05 1.028h-9.37a2.85 2.85 0 0 0-1.166-2.055h6.466v-2.053H4.28v2.053h2.44a2.85 2.85 0 0 0-1.167 2.055H3.86l-.171-.01a1.66 1.66 0 0 1-1.498-1.466l-.01-.167V6.007c.001-.908.752-1.643 1.68-1.644zm-12.84 7.805H16.7V6.417H4.28z"
                clipRule="evenodd"
            />
            <path
                fill="currentColor"
                d="M9.57 18.577c0-.592-.49-1.072-1.094-1.072s-1.096.48-1.096 1.072.491 1.072 1.096 1.072c.604 0 1.095-.48 1.095-1.072m2.216 0c0 1.79-1.482 3.241-3.31 3.241s-3.31-1.45-3.31-3.241c0-1.79 1.481-3.241 3.31-3.241s3.31 1.45 3.31 3.24"
            />
        </svg>
    );
};

export default React.memo(DropTrailerLine);
